import React, { useEffect } from 'react';
import Loading from '@shared/components/loading/Loading';
import { APITokenModal } from '../integration-strategies/modal-strategy/templates/api-token';
import { toCancellable } from '../../../shared/axios';
import { usePipedrive } from './pipedrive.hooks';

export const Pipedrive = () => {
    const {
        loading,
        submitting,
        loadInitialData,
        integrationData,
        save,
    } = usePipedrive();

    useEffect(() => toCancellable(loadInitialData()), [loadInitialData]);


    if (loading) return <Loading />;

    return (
        <APITokenModal
            onSubmit={save}
            isSubmitting={submitting}
            initialData={{ apiToken: integrationData }}
        />
    );
};
